<template>
  <div class="lottery-wheel" :class="cssType">
    <!-- {{ globalConfig.displayList }} 9999888 -->
    <div class="lottery-wheel-items" :class="state.className">
      <div
        class="lottery-wheel-item"
        :class="{ active: state.activeIndex === index }"
        v-for="(item, index) in globalConfig.displayList"
        :key="index"
      >
        <img class="img" :src="`${PUBLIC_PATH}imgs/props/${item.propId}.png`" alt="icon">
        <span class="text">
          * {{ item.count }}
        </span>
      </div>
    </div>
    <div class="lottery-wheel-arrow-wrapper">
      <div class="lottery-wheel-arrow"></div>
    </div>
  </div>
</template>
<script setup>
import { reactive, inject, defineExpose } from 'vue'
import { isMobile } from '@/utils'
import CnyActApi from '@/config/cnyActApi'
import { useLog } from '@/composables/useLog'
const log = useLog()
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const globalConfig = inject('globalConfig')
const getUserLotteryDetail = inject('getUserLotteryDetail')
const cssType = isMobile ? 'mobile' : 'pc'

const toggleLotteryRewardDialog = inject('toggleLotteryRewardDialog')

const state = reactive({
  activeIndex: -1,
  // rewardIndex: -1,
  rotateAngle: 0,
  isRotating: false,
  className: '',
})

const doLottery = async (skipAnimation = false) => {
  // 如果正在旋转，不执行
  if (state.isRotating) return
  state.isRotating = true
  
  const res = await CnyActApi.lottery()
  console.log('lottery res', res)
  try {
    log.track('act_cny_lottery_once', {
      v1: res.lotteryRewardCode,
    })
  } catch (error) {
    console.error(error)
  }
  const lotteryRewardCode = res.lotteryRewardCode
  const currentItem = globalConfig.displayList.find(item => item.lotteryRewardCode === lotteryRewardCode)
  if (skipAnimation) {
    state.isRotating = false
    toggleLotteryRewardDialog(true, { rewards: [currentItem] }, (value) => {
      console.log('value', value)
    })
    getUserLotteryDetail()
    return
  }

  const index = globalConfig.displayList.findIndex(item => item.lotteryRewardCode === currentItem.lotteryRewardCode)
  // state.rewardIndex = currentItem.id
  console.log('currentItem.lotteryRewardCode', currentItem.lotteryRewardCode, index)
  state.className = ''
  setTimeout(() => {
    state.activeIndex = -1
    state.className = 'rotate-' + index
    setTimeout(() => {
      state.isRotating = false
      toggleLotteryRewardDialog(true, { rewards: [currentItem] }, (value) => {
        console.log('value', value)
      })
      getUserLotteryDetail()
    }, 4000)
    setTimeout(() => {
      state.activeIndex = index
    }, 3200)
  }, 100)
}

const doLotteryOneKey = async (skipAnimation = false) => {
  // lotteryRewardCodeList
  // 如果正在旋转，不执行
  if (state.isRotating) return
  state.isRotating = true
  
  const res = await CnyActApi.lotteryAll()
  console.log('lotteryAll res', res)
  try {
    log.track('act_cny_lottery_all', {
      v1: res.lotteryRewardCodeList.join(','),
    })
  } catch (error) {
    console.error(error)
  }
  const lotteryRewardCodeList = res.lotteryRewardCodeList
  const lotteryRewardCode = lotteryRewardCodeList[0]
  const currentItem = globalConfig.displayList.find(item => item.lotteryRewardCode === lotteryRewardCode)
  const currentItems = []
  lotteryRewardCodeList.forEach(item => {
    const displayItem = globalConfig.displayList.find(displayItem => displayItem.lotteryRewardCode === item)
    if (!displayItem) return
    currentItems.push(displayItem)
  })
  if (skipAnimation) {
    state.isRotating = false
    toggleLotteryRewardDialog(true, { rewards: currentItems }, (value) => {
      console.log('value', value)
    })
    getUserLotteryDetail()
    return
  }

  const index = globalConfig.displayList.findIndex(item => item.lotteryRewardCode === currentItem.lotteryRewardCode)
  // state.rewardIndex = currentItem.id
  console.log('currentItem.lotteryRewardCode', currentItem.lotteryRewardCode, index)
  state.className = ''
  setTimeout(() => {
    state.activeIndex = -1
    state.className = 'rotate-' + index
    setTimeout(() => {
      state.isRotating = false
      toggleLotteryRewardDialog(true, { rewards: currentItems }, (value) => {
        console.log('value', value)
      })
      getUserLotteryDetail()
    }, 4000)
    setTimeout(() => {
      state.activeIndex = index
    }, 3000)
  }, 100)
}

defineExpose({
  doLottery,
  doLotteryOneKey
})

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
